import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=07d95250&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=ts"
export * from "./Stories.vue?vue&type=script&lang=ts"
import style0 from "./Stories.vue?vue&type=style&index=0&id=07d95250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d95250",
  null
  
)

export default component.exports